export const FORM_FIELDS = {
  KEYWORDS: 'keywords',
  KEYWORDS_EXACT: 'keywords-exact',
  SENDER: 'from',
  SENDER_DOMAINS: 'from-domains',
  PARTICIPANTS: 'participants',
  PARTICIPANTS_DOMAINS: 'participants-domains',
  DATE: 'dates',
  ATTACHMENTS: 'attachments',
  SIZE: 'sizes',
  HOLD_REASON: 'holds',
  TAG: 'tags',
  KEYWORD_LIST: 'keyword-list',
  USER_LISTS: 'user-lists',
};

export const DATE_TYPES = {
  AFTER: 'after',
  BEFORE: 'before',
  SPECIFIC: 'specific',
  RANGE: 'range',
};

export const ATTACHMENT_TYPES = {
  WITH_ATTACHMENTS: 'with_attachments',
  WITHOUT_ATTACHMENTS: 'without_attachments',
};

export const SIZE_TYPES = {
  HUGE: 'huge',
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
};

export const TAG_TYPES = {
  ASSET_REVIEWED: 'asset_reviewed',
  ASSET_NEEDS_REVIEW: 'asset_needs_review',
  NO_REVIEW_STATE: 'no_review_state',
};

export default {
  FORM_FIELDS,
  DATE_TYPES,
  ATTACHMENT_TYPES,
  SIZE_TYPES,
  TAG_TYPES,
};
